import * as React from "react";
const SvgHealthMetrics = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      stroke="currentColor"
      d="M9 2.5h6c.416 0 .76.143 1.059.441.298.3.441.643.441 1.059v3.5H20c.416 0 .76.143 1.059.441.298.3.441.643.441 1.059v6c0 .416-.143.76-.441 1.059A1.43 1.43 0 0 1 20 16.5h-3.5V20c0 .416-.143.76-.441 1.059A1.43 1.43 0 0 1 15 21.5H9c-.416 0-.76-.143-1.059-.441A1.43 1.43 0 0 1 7.5 20v-3.5H4c-.416 0-.76-.143-1.059-.441A1.43 1.43 0 0 1 2.5 15V9c0-.416.143-.76.441-1.059A1.43 1.43 0 0 1 4 7.5h3.5V4c0-.416.143-.76.441-1.059A1.43 1.43 0 0 1 9 2.5Zm3.825 8.592-1.35 4.05a.5.5 0 0 1-.194.254.5.5 0 0 1-.306.104.47.47 0 0 1-.232-.062.45.45 0 0 1-.169-.153l-.004-.007-.004-.005-1.7-2.55-.148-.223H3.5v3H8a.47.47 0 0 1 .36.14.47.47 0 0 1 .14.36v4.5h7V16a.47.47 0 0 1 .14-.36.47.47 0 0 1 .36-.14h4.5v-3H15a.47.47 0 0 1-.232-.062.7.7 0 0 1-.212-.181l-.837-1.28-.567-.866zM8.5 8a.47.47 0 0 1-.14.36.47.47 0 0 1-.36.14H3.5v3H9c.08 0 .154.02.232.063a.45.45 0 0 1 .17.152l.003.008.005.006.875 1.3.567.844.323-.965 1.35-4.05a.53.53 0 0 1 .19-.26.466.466 0 0 1 .517-.035.45.45 0 0 1 .17.152l.003.007.004.006 1.7 2.55.149.222H20.5v-3H16a.47.47 0 0 1-.36-.14.47.47 0 0 1-.14-.36V3.5h-7z"
    />
  </svg>
);
export default SvgHealthMetrics;
